import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    type: "hidden",
    name: "type",
    value: "dynamic"
};
const _hoisted_2 = { class: "list list--md" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "line" };
const _hoisted_5 = { class: "line__item" };
const _hoisted_6 = ["data-type"];
const _hoisted_7 = { class: "btn__icon" };
const _hoisted_8 = {
    key: 0,
    class: "line__item line__item--mla"
};
const _hoisted_9 = {
    href: "/profile/addresses/",
    class: "btn btn--4 btn--s btn--black"
};
const _hoisted_10 = { class: "btn__icon" };
const _hoisted_11 = { class: "line line--aic" };
const _hoisted_12 = { class: "line__item line__item--mla" };
const _hoisted_13 = ["disabled"];
import Icon from "../../components/Icon.vue";
import ModalDialog from "../../components/modal/ModalDialog.vue";
import DeliveryAddress from "../../components/delivery/DeliveryAddress.vue";
import { computed, onBeforeMount, ref, watch } from "vue";
import { hidePreloader, showPreloader } from "../../components/preloader";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddressSelectApp',
    props: /*@__PURE__*/ _mergeModels({
        addresses: { type: Array, default: [] },
        address: { type: Object },
        noRedirect: Boolean,
        userLoggedIn: Boolean,
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(["select"], ["update:modelValue"]),
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const selected = _useModel(__props, "modelValue");
        const modal = ref();
        const disabled = computed(() => !props.addresses.find(a => a.address.id === selected.value)?.delivery.available);
        const emit = __emit;
        __expose({
            show: () => modal.value.open(),
            showLoader: () => showPreloader(modal.value.isOpen() ? modal.value.wrapper.querySelector('.modal__wrapper') : null),
        });
        function onSave(event) {
            const current = props.addresses.find(({ address }) => address.id === selected.value);
            if (!current.delivery?.available) {
                event.stopPropagation();
                event.preventDefault();
                return false;
            }
            emit('select', current.address, current.delivery);
            if (props.noRedirect) {
                modal.value.close();
                setTimeout(hidePreloader);
            }
        }
        watch(() => props.address, address => selected.value = address?.id);
        onBeforeMount(() => selected.value = props.address?.id);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                id: "addresses",
                size: "lg",
                title: "Выбор способа доставки",
                ref_key: "modal",
                ref: modal,
                open: !__props.noRedirect,
                noRedirect: __props.noRedirect
            }, _createSlots({
                main: _withCtx(() => [
                    (__props.noRedirect)
                        ? (_openBlock(), _createElementBlock("input", _hoisted_1))
                        : _createCommentVNode("v-if", true),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createElementVNode("ul", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.addresses, (item) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "list__item",
                                key: item.address.id
                            }, [
                                _createVNode(DeliveryAddress, {
                                    address: item.address,
                                    delivery: item.delivery,
                                    available: item.delivery?.available,
                                    bordered: "",
                                    radio: "",
                                    modelValue: selected.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selected).value = $event))
                                }, null, 8 /* PROPS */, ["address", "delivery", "available", "modelValue"])
                            ]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _cache[7] || (_cache[7] = _createTextVNode()),
                        (__props.noRedirect)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn--4 btn--s btn--black win",
                                            "aria-controls": "modal-add-address",
                                            "data-act": "edit_address",
                                            "data-type": __props.noRedirect ? 'dynamic' : null
                                        }, [
                                            _createElementVNode("span", _hoisted_7, [
                                                _createVNode(Icon, { name: "add" })
                                            ]),
                                            _cache[2] || (_cache[2] = _createTextVNode()),
                                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "btn__label" }, "Добавить", -1 /* CACHED */))
                                        ], 8 /* PROPS */, _hoisted_6)
                                    ]),
                                    _cache[6] || (_cache[6] = _createTextVNode()),
                                    (__props.userLoggedIn)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createElementVNode("a", _hoisted_9, [
                                                _createElementVNode("span", _hoisted_10, [
                                                    _createVNode(Icon, { name: "edit" })
                                                ]),
                                                _cache[4] || (_cache[4] = _createTextVNode()),
                                                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "btn__label" }, "Редактировать", -1 /* CACHED */))
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                bottom: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "line__item" }, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--2 btn--m btn--gray",
                                "data-close": ""
                            }, [
                                _createElementVNode("span", { class: "btn__label" }, "Отмена")
                            ])
                        ], -1 /* CACHED */)),
                        _cache[11] || (_cache[11] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn--2 btn--m btn--black ajax_submit",
                                "data-act": "select_address",
                                disabled: disabled.value,
                                onClick: onSave
                            }, [...(_cache[9] || (_cache[9] = [
                                    _createElementVNode("span", { class: "btn__label" }, "Сохранить", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_13)
                        ])
                    ])
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (!__props.noRedirect)
                    ? {
                        name: "under_top",
                        fn: _withCtx(() => [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal__under-top" }, [
                                _createElementVNode("div", { class: "text text--sm" }, [
                                    _createTextVNode("\n          Добавить новые и изменить существующие способы доставки можно на странице «"),
                                    _createElementVNode("a", { href: "/profile/addresses/" }, "Адреса доставки"),
                                    _createTextVNode("»\n        ")
                                ])
                            ], -1 /* CACHED */))
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["open", "noRedirect"]));
        };
    }
});
